export default __webpack_public_path__ + "5352de12fe69a0161288447f9e01334c.webp";